import { ReactElement } from 'react';

enum LaneIds {
  ContinueLearning = 'continueLearning',
  SavedForLater = 'favorites',
  LiveEvents = 'liveEvents',
  NewOfferings = 'newOfferings',
  SkillsAssessments = 'skillsAssessments',
  SkillsPaths = 'skillsPaths',
  TrialSubscriptions = 'trialSubscription',
}

export type CommonLaneProps = {
  expanded: boolean;
  onTitleClick: () => void;
};

export type LaneConfig = {
  component: ReactElement;
  id: LaneIds;
  visible: boolean;
};

export const laneAnchorId = (laneId: LaneIds) => `lane-${laneId}`;

export default LaneIds;
